import { Box, BoxProps } from "@mui/material"
import React, {
  forwardRef,
  MutableRefObject,
  SyntheticEvent,
  useImperativeHandle,
} from "react"
import { useRef } from "react"

import transparent from "../images/transparent.png"

const fallbackImage = (imageRef: MutableRefObject<HTMLImageElement | null>) => {
  if (imageRef.current && imageRef.current.src !== `${transparent}`)
    imageRef.current.src = `${transparent}`
}

export const Image = forwardRef<
  HTMLImageElement | null,
  BoxProps<"img"> & { hasTransparentFallback?: boolean }
>(({ hasTransparentFallback, src, onError, ...rest }, ref) => {
  useImperativeHandle(ref, () => imageRef.current as HTMLImageElement)
  const imageRef = useRef<HTMLImageElement>(null)
  return (
    <Box
      ref={imageRef}
      src={src ?? (hasTransparentFallback ? `${transparent}` : undefined)}
      component={"img"}
      onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
        fallbackImage(imageRef)
        if (onError) onError(e)
      }}
      {...rest}
    />
  )
})
